import PropTypes from 'prop-types';

import React, { PureComponent } from 'react';
import { BannerContainer, BannerCloseButton } from './banner.styles';
import { Text } from '../text';
import { identifiers } from '../../utils/rendering';

export class Banner extends PureComponent {
  static propTypes = {
    contentEntry: PropTypes.object,
    closeBanner: PropTypes.func,
  };

  componentDidMount() {}

  render() {
    const { contentEntry, closeBanner } = this.props;
    const handleBannerClose = () => {
      closeBanner(contentEntry.getIn(['sys', 'id']));
    };

    if (!contentEntry) { return null; }

    const title = contentEntry.getIn(['fields', 'title']);
    const text = contentEntry.getIn(['fields', 'text']);
    const buttonUrl = contentEntry.getIn(['fields', 'buttonUrl', 'fields', 'url']);
    const buttonLabel = contentEntry.getIn(['fields', 'buttonLabel']);

    return (
      contentEntry &&
      !contentEntry.isEmpty() && (
        <BannerContainer
          {...identifiers(
            'Banner',
            contentEntry.getIn(['sys', 'contentType', 'sys', 'id']),
            contentEntry.getIn(['sys', 'id']),
          )}
          data-offset-sidemenu={true}
          ref={this.bannerRef}
        >
          <Text>
            {`${title ? `**${title}**` : ''} ${text} ${
              buttonUrl ? `[${buttonLabel}](${buttonUrl})` : ''
            }`}
          </Text>
          <BannerCloseButton onClick={handleBannerClose} />
        </BannerContainer>
      )
    );
  }
}
